/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserDetailUserType
 */
export interface UserDetailUserType {
    /**
     * 
     */
    type?: string;
    /**
     * 
     */
    title?: string;
}

/**
 * Check if a given object implements the UserDetailUserType interface.
 */
export function instanceOfUserDetailUserType(value: object): value is UserDetailUserType {
    return true;
}

export function UserDetailUserTypeFromJSON(json: any): UserDetailUserType {
    return UserDetailUserTypeFromJSONTyped(json, false);
}

export function UserDetailUserTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserDetailUserType {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'title': json['title'] == null ? undefined : json['title'],
    };
}

export function UserDetailUserTypeToJSON(json: any): UserDetailUserType {
    return UserDetailUserTypeToJSONTyped(json, false);
}

export function UserDetailUserTypeToJSONTyped(value?: UserDetailUserType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'title': value['title'],
    };
}

